export default __webpack_public_path__ + "static/media/Hospital.4097dc4b.svg";